import {
  AccountList,
  AccountWithoutPassword,
  AllDataAccountList,
  UpdateAccount,
} from "../generated/types";
import { apiFetchJson } from "./apiFetchRoute";

/** Corps de PUT /accounts : le back refuse tout champ hors UpdateAccount. */
export const toUpdateAccount = (
  account: AccountWithoutPassword
): UpdateAccount => ({
  language: account.language,
  id_company: account.id_company,
  email: account.email,
  first_name: account.first_name,
  last_name: account.last_name,
  phone_mobile: account.phone_mobile,
  phone_fixe: account.phone_fixe,
  avatar: account.avatar,
});

export const fetchAllDataUsers = async (): Promise<{
  users: AllDataAccountList | [];
  error: string | null;
}> => {
  try {
    const data = await apiFetchJson("getAdminAccountsAlldata", undefined);

    return { users: data, error: null };
  } catch (err) {
    console.error("Erreur:", err);
    return { users: [], error: "Impossible de charger les utilisateurs" };
  }
};

export const fetchAccounts = async (): Promise<{
  Users: AccountList | [];
  error: string | null;
}> => {
  try {
    const data = await apiFetchJson("getAccounts", undefined);

    return { Users: data, error: null };
  } catch (err) {
    console.error("Erreur:", err);
    return { Users: [], error: "Impossible de charger les entreprises" };
  }
};
